import * as React from 'react';
import { Redirect } from 'react-router-dom';
import {
  Container,
  Content,
  ContainerServices,
  ContentFormServices
} from './styled';

import { SidebarFeature } from '@app/src/commons/sidebar';
import { useAuthorization } from '@app/src/utils/validations';
import { Select } from '@app/src/components/Select';
import { Button } from '@app/src/components/Button';
import { Field } from '@app/src/components/Field';
import { getSettings } from '@app/src/configuration/config.service';
import { servicesUserService } from './state/services';


export const UserServices = ({ history }) => {

  const isValid = useAuthorization();
  
  React.useEffect(() => {
    sessionStorage.setItem("wentFlowMultMerch", "0");
  }, []);

  const [isReady, setIsReady] = React.useState(false);
  const [services, setServices] = React.useState<Array<{ value: string; label: string }>>([]);
  const [selectedService, setSelectedService] = React.useState<string>(null);

  React.useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const url = getSettings().API_USER_SERVICES;
        const list = await servicesUserService.listServicesByUser(url);
        if (!mounted) return;
        if (list && Array.isArray(list)) {
          const options = list.map((s) => ({ value: String(s.IdServicio), label: s.NombreServicio }));
          setServices(options);
          if (options.length > 0) setSelectedService(options[0].value);
        } else {
          setServices([]);
          setSelectedService(null);
        }
      } catch (e) {
        setServices([]);
        setSelectedService(null);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);
  
  const handleContinue = async () => {
    if(selectedService){
      const url = getSettings().API_USER_SET_SERVICE;
      const response = await servicesUserService.setService(selectedService, url);
      sessionStorage.setItem("wentFlowMultMerch", "1");

      setIsReady(response);
    }
    
  };
  
  if (!isValid) {
    return <Redirect to="/" />;
  }
  if(!isReady){
    return (
        <>
            <Container>
            <SidebarFeature history={history} enabledButtons={false} />
            <Content>
                <ContainerServices>
                <ContentFormServices data-test="serviceForm">
                    <Field label={"Seleccione un servicio"} dataLabel="serviceLabelDescribe">
                    <Select
                        onChange={(val) => setSelectedService(val.target.value)}
                        options={services}
                        data-test="serviceSelectService"
                    />
                    </Field>
                    <Button data-test="serviceButtonContinue" width='100%' disabled={!selectedService} primary type="button" onClick={() => handleContinue()}>Continuar</Button>
                </ContentFormServices>
                </ContainerServices>
            </Content>
            </Container>
        </>
    );
  }

  return <Redirect to="/generarcip" />;
};
